import { TimelineMax, TweenLite } from "gsap";
import { IDimConfig, ResizeHelper } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { SplashView } from "../SplashController"
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { SanGameConfig } from "../../../../SanGameConfig";
import { Translation } from "@nolimitcity/slot-game/bin/core/translation/Translation";
import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { PosterManager } from "../../poster/PosterManager";
import { SpinePlayer } from "../../../../proto/SpinePlayer";
import { SoundManager } from "../../../../resource/sound/SoundManager";
import { WinCounter } from "../../countup/WinCounter";
import { NormalWinPresentation } from "../../../features/normalwin/NormalWinPresentation";
import { SoundConfig } from "../../../../SoundConfig";
import { ParticlesManager } from "../../particles/ParticlesManager";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { JurisdictionNames } from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/GameClientConfiguration";

export class SplashBrokenBank extends BaseView implements SplashView {

    protected _sp:PIXI.Sprite;
    protected _spine:SpinePlayer;
    private _timeLine: TimelineMax;

    private static totalWon:number = 0;
        

    protected layoutDim: IDimConfig = {
        dimOrientation: {
            landscape: {
                scale: new PIXI.Point(1, 1),
                position: new PIXI.Point(360, 300),
                layout: {
                    left: new PIXI.Point(360, 300),
                    right: new PIXI.Point(360, 300)
                }
            },
            portrait: {
                scale: new PIXI.Point(1.1, 1.1),
                position: new PIXI.Point(360, 300)
            }
        },
        WIDTH: 240,
        HEIGHT: 64,
    };

    constructor(textStyle: TextStyleOptions) {
        super();
        
        this.visible = false;

        StageManager.getLayer(SanGameConfig.instance.LAYERS.POSTER.name).addChild(this);
    }

    public static setTotalWinAmount(val:number){
        this.totalWon = val;
    }

    public play(): TimelineMax {

        const juriName:string = SlotGame.api.gameClientConfiguration.jurisdictionName === JurisdictionNames.ITALY ? "_ITALY" : "";

        this._timeLine = Helper.timeLineKiller(this._timeLine, new TimelineMax({ onStart: () => { SoundManager.playManiac1(); this.visible = true }}));
        
        this._timeLine.add(WinCounter.normalCounter.maniacUpAnimation(0,SplashBrokenBank.totalWon,15.876,1));
        PosterManager.instance.playManiac(0.2,{config:{
            animationName:"Big_Win_6_Start",
            loop:true
        }})

        ParticlesManager.playMinicwin();
        
        this._timeLine.add([
            () => WinCounter.normalCounter.bounceHit(10,0.5,true),
            () => ParticlesManager.playManiacwin(),
            () => NormalWinPresentation.winAnim.winLvlManiacAnimation(3),
            () => SoundManager.playManiac2(),
            () => SoundManager.playSoundEffect(SoundConfig.instance.BIG_WIN_EXPLODE),
            () => WinCounter.normalCounter.abort(),
            () => PosterManager.instance.playManiac(0.2,{config:{
            animationName:"Big_Win_6"+juriName,
            loop:true
            }})
        ],15.876)

        this._timeLine.add([
            TweenLite.fromTo(this,0.5,{alpha:0},{alpha:1})
        ],"+=" + 1)

        return this._timeLine;
    }

    public stop(): TimelineMax {
        this._timeLine = Helper.timeLineKiller(this._timeLine, new TimelineMax());
        this._timeLine.to(this, 0.35, { alpha: 0 },0);
        ParticlesManager.stopBigWin();
        this._timeLine.add(PosterManager.instance.stop(0.35),0);
        return this._timeLine;
    }

    public onResize(): void {
        if (this._timeLine && this._timeLine.isActive()) this._timeLine.progress(1);

        this.position = ResizeHelper.calcDim(this.layoutDim).position;
        this.scale = ResizeHelper.calcDim(this.layoutDim).scale;
    }
}
